export * from './components';
import utils from './utils';
import theme from './theme';
import useDevice from './core/hooks/useDevice';
import ThemeProvider, { withTheme, useTheme } from './core/ThemeProvider';
import gomoColors from './theme/advance/colours';

export {
  /** DLS theme */
  theme,
  /**
   * Top level Wrapper for all DLS components.
   * Provides config props for theming to all child DLS components.
   */
  ThemeProvider,
  withTheme,
  useTheme,
  /** Utility functions */
  utils,
  // GOMO colors
  gomoColors,
  // useDevice hook
  useDevice
};
